import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { canSee } from "../../lib/roles";
import { InsuranceBanner } from "../assets/AssetBanners";

// Dashboard: 30 gün içinde biten DASK / konut / trafik / kasko poliçeleri; satıra tıklayınca demirbaş kartı açılır (ESC ile geri)
export default function InsuranceDueCard() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();
  const allowed = canSee(user, "/demirbaslar");
  useEffect(() => {
    if (!allowed) return;
    http.get("/fixed-assets/insurance-due?days=30").then((r) => setItems(r.data)).catch(() => {});
  }, [allowed]);
  if (!allowed) return null;
  return <InsuranceBanner items={items} onOpen={(id) => navigate(`/demirbaslar?kayit=${id}&don=${encodeURIComponent("/dashboard")}`)} />;
}
